module.exports = __webpack_public_path__ + "static/media/05C.0bb2177d.png";